// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1bbKY","info":"UpdateTermsInfo_info__DZieQ"};